import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const scheduledSearchSchema = z.object({
    editId: z.string().uuid().optional(),
});

// Scheduled outreaches moved to a tab on the Outreaches page. Keep this route
// as a redirect so old bookmarks and deep links (including editId) still work.
export const Route = createFileRoute('/_app/(main)/scheduled/')({
    validateSearch: scheduledSearchSchema,
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/outreaches',
            search: { tab: 'scheduled', editId: search.editId },
            replace: true,
        });
    },
});
